/*
 * @Author: llzq
 * @Date: 2021-10-24 13:32:01
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:46:59
 * @Description:  头部注释
 */
import React, { Component } from 'react'
import {Icon} from 'antd'
// model
import ChapterClazzItem from '../models/chapterClazzItem'

interface iProps {
    chapterClazzItem: ChapterClazzItem
    progressShow?: boolean,
    playing?: boolean // 是否正在播放
    itemClick: (chapterClazzItem: ChapterClazzItem) =>  void
}

export default class ClazzItemView extends Component<iProps> {
    render() {
        let {chapterClazzItem, progressShow, playing = false} = this.props
        return (
            <div onClick={this.props.itemClick.bind(null, chapterClazzItem)} className={playing ? 'chapterClazzViewOfMenu chapterItemViewPlaying' : 'chapterClazzViewOfMenu'}>
                <div className="chapterClazzViewOfMenu_left">
                    {/* <div className={chapterClazzItem.classTaskType ==='DOCUMENT' ? `${chapterClazzItem.classTaskType} ${chapterClazzItem.suffix?.split('.')[1]}`: chapterClazzItem.classTaskType}></div> */}
                    <div className={`chapterClazzViewOfMenu_name ${chapterClazzItem.classTaskType === 'LIVE' ? `portal-LIVE portal-${chapterClazzItem.livePlatform} portal-${chapterClazzItem.liveType}` : `portal-${chapterClazzItem.classTaskType}`}`}>{chapterClazzItem.title}</div>
                </div>
                {progressShow &&
                <div className="chapterClazzViewOfMenu_right">
                    <div className={chapterClazzItem.studyState}></div>
                </div>}
            </div>
        )
    }
}
